/* eslint-disable-next-line  no-unused-vars */
import React, { createElement, useEffect, useRef, useState, useContext } from 'react';
import { Wrapper, Status } from '@googlemaps/react-wrapper';
import MapComponent from './MapComponent';
import '../assets/css/_variables.scss';
import './MapStyle.scss';
import styleConfigHelper from '../helper/styleConfigHelper';
import DrawComponent from '../drawing/DrawComponent';
import appModes from '../helper/appModes';
import LegendComponent from '../legend/LegendComponent';
import MeasureComponent from '../measure/MeasureComponent';
import applicationMode from '../helper/applicationMode';
import Marker from './Marker';
import ShowMessageComponent from './ShowMessageComponent';
import ActionComponent from '../action/ActionComponent';
import firebaseHelper from '../helper/firebaseHelper';
import MapLoader from './MapLoader';
import AddSupplierComponent from '../supplier/AddSupplierComponent';
import GroupData from '../supplier/GroupData';

const render = (status) => {
    if (status === Status.LOADING) return <h3>{status} ..</h3>;
    if (status === Status.FAILURE) return <h3>{status} ...</h3>;
    return null;
};

export default function Map({ apiKey, mapData, mapOptions, symbolConfig, layerData, firebaseConfig }) {
    const [messages, setMessages] = useState([]);

    let {
        LegendEnabled,
        MeasureEnabled,
        DrawingEnabled,
        ApplicationMode,
        ActionMenuEnabled
    } = appModes(mapOptions);

    if (!layerData || layerData?.length == 0) {
        if (ApplicationMode === applicationMode.single) LegendEnabled = false;
    }

    useEffect(() => {
        let customMessages = [];

        if (ApplicationMode !== applicationMode.mini) {
            let fhelper = new firebaseHelper(firebaseConfig);
            if (!fhelper.getStatus()) {
                // customMessages.push("Firebase Configuration Failed");
            }
        }

        if (!apiKey || apiKey == '') {
            customMessages.push("Google API Key not found");
        }

        setMessages(customMessages);
    }, []);

    useEffect(() => {
        if (symbolConfig) {
            let conf = new styleConfigHelper();
            conf.updateConfig(symbolConfig);
        }
    }, [symbolConfig]);

    const callbackFunc = (status) => {
        if (status == 'SUCCESS') {
            console.log('Google Api Loaded');
        }
    };

    const mapCallbackFunc = () => {
        // console.log(map);
    };

    return (
        <div id="oemGisMap">
            <Wrapper
                apiKey={apiKey}
                render={render}
                callback={callbackFunc}
                version={'beta'}
                libraries={['geometry', 'places', 'visualization']}
            >
                <MapLoader status={false} />
                <MapComponent callbackFunc={mapCallbackFunc} mapOptions={mapOptions}>
                    <Marker mapData={mapData} mapOptions={mapOptions} />
                    {DrawingEnabled && (
                        <div>
                            {' '}
                            <DrawComponent />{' '}
                        </div>
                    )}
                    <AddSupplierComponent />
                    {LegendEnabled && (
                        <LegendComponent
                            legendTitle={mapOptions?.LegendTitle}
                            appMode={ApplicationMode}
                        />
                    )}
                    {ActionMenuEnabled && (
                        <ActionComponent measureEnabled={MeasureEnabled} >
                            <div>{MeasureEnabled && <MeasureComponent />}</div>
                        </ActionComponent>
                    )}
                    <ShowMessageComponent customMessages={messages} />
                    <GroupData />
                </MapComponent>
            </Wrapper>
        </div>
    );
}
